import React, { useState, forwardRef } from "react";
import { Typography, Paper, Grid, FormControl } from "@material-ui/core";
import useStyles from "../../styles/deviceTaskStyle";
import SelectDate from "../device/SelectDate";
import { CommandTextField } from "../commons/Textfields";
import { useTranslation } from "../../langs/useTranslation";
import { Formik, Form } from "formik";
import CommandConfirmDialog from "../commons/CommandConfirmDialog";
import SendRoundedIcon from "@material-ui/icons/SendRounded";
import * as localforage from "localforage";
import { restartSystemAPI } from "../../apis/restartSystemAPI";
import { StyledSubmitBtn, BackBtn } from "../commons/FormBtns";
import {
  handleClose,
  handleHasResponseStatus
} from "../../helpers/commandConfirmationDialogAction";
import {
  restartSystemValuesSchema,
  restartSystemInitialValues
} from "../../config/singleDeviceTaskValuesSchema";
import { DateTimeComparisonText } from "../commons/ValidationText";

const RestartSystemSingleForm = forwardRef((props, ref) => {
  const classes = useStyles();
  const {
    executeType,
    deviceId,
    devices,
    storedDatePickerValueToLocalforageName,
    resetAllStoredValueInLocalforage,
    successfulText,
    dispatch
  } = props;
  const { t } = useTranslation("task");
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({});
  const [datetime, setDatetime] = useState(true);
  const [isExecuting, setIsExecuting] = useState(false);

  const handleExecuteAction = async () => {
    setIsExecuting(true);
    // Execute the task after modal opened and the confirm button clicked
    const command = values.command;
    const selectedIds = [];
    const responseStatus = await restartSystemAPI(
      deviceId,
      devices,
      selectedIds,
      executeType,
      datetime,
      command,
      t,
      successfulText
    );
    if (responseStatus) {
      handleHasResponseStatus(setOpen, resetAllStoredValueInLocalforage);
    }
    dispatch({ type: "stopLoading" });
  };

  return (
    <Formik
      initialValues={restartSystemInitialValues}
      validationSchema={restartSystemValuesSchema}
      onSubmit={async values => {
        dispatch({ type: "showLoading" });
        setValues(values);
        const datetime =
          values.date === "immediately"
            ? "immediately"
            : await localforage.getItem(storedDatePickerValueToLocalforageName);
        setDatetime(datetime);
        if (datetime) {
          setOpen(true);
        } else {
          dispatch({ type: "stopLoading" });
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit
      }) => (
        <Form onSubmit={handleSubmit}>
          <FormControl fullWidth={true} ref={ref}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Paper elevation={0} className={classes.fullWidthPaper}>
                  <Typography variant="h6">{t("task.selectDate")}</Typography>
                  <SelectDate
                    storedDatePickerValueToLocalforageName={
                      storedDatePickerValueToLocalforageName
                    }
                    formikName="date"
                    formikOnChange={handleChange}
                    formikValue={values.date}
                    formikError={errors.date && touched.date && errors.date}
                  />
                  {!datetime ? <DateTimeComparisonText /> : ""}
                </Paper>
                <Paper elevation={0} className={classes.fullWidthPaper}>
                  <CommandTextField
                    CommandTextFieldPlaceHolder="e.g. taskkill /f /im chrome.exe"
                    formikName="command"
                    formikOnChange={handleChange}
                    formikOnBlur={handleBlur}
                    formikValue={values.command}
                  />
                </Paper>
                <div className="submit-back-btn-wrap">
                  <StyledSubmitBtn
                    startIcon={<SendRoundedIcon />}
                    btnText={t("btn.confirmBtn")}
                    type="submit"
                  />
                  <BackBtn />
                  <CommandConfirmDialog
                    isExecuting={isExecuting}
                    okBtnOnClick={handleExecuteAction}
                    backBtnOnClick={() =>
                      handleClose(setOpen, dispatch, setIsExecuting)
                    }
                    open={open}
                    dialogTitle={t("task.restartSystemName")}
                    dialogContent={t(
                      "modal.singleDeviceRestartSystemDescription"
                    )}
                  />
                </div>
              </Grid>
            </Grid>
          </FormControl>
        </Form>
      )}
    </Formik>
  );
});

export default RestartSystemSingleForm;
